"use client";

import { useState } from "react";
import { twMerge } from "tailwind-merge";

/**
 * @param {string} children - the text to be truncated
 * @param {string} readMoreText - the text to be displayed when the text is truncated
 * @param {string} readLessText - the text to be displayed when the text is not truncated
 * @param {string} className - the class name to be applied to the container
 * @param {string} buttonClassName - the class name to be applied to the button
 * @param {number} limit - the number of characters to be displayed when the text is truncated
 */
export const ReadMoreOrLess = ({
  children,
  readMoreText = "閱讀更多",
  readLessText = "閱讀較少",
  className,
  buttonClassName,
  limit = 50,
}: {
  children?: string;
  readMoreText?: string;
  readLessText?: string;
  className?: string;
  buttonClassName?: string;
  limit?: number;
}) => {
  const [expanded, setExpanded] = useState(() => false);

  if (!children) return null;
  return (
    <p className={className}>
      {expanded ? children : children.substring(0, limit).concat("...")}
      <button
        className={twMerge("cursor-pointer text-sky-700", buttonClassName)}
        onClick={() => setExpanded((prev) => !prev)}
      >
        {expanded ? readLessText : readMoreText}
      </button>
    </p>
  );
};
